module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/visa-c62c02485039ff413f9c3512804c5dec.png";